import Button from "components/common/buttons/buttons";
import { Forward } from "components/common/Icons";
import List from "components/common/List/list";
import StockDetailLink from "components/common/StockDetailLink";
import Loading from "components/organisms/m/Loading";
import moment from "moment-timezone";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { TYPO } from "styles/Typo";
import { KOREA } from "utils/constant/ITME_INFO";
import { getStockLogo } from "utils/image";
import InterestNoList from "./NoList";
import { TrackedNewsRaderLink } from "lib/analytics/react/link";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";

const TopGainLoss = ({ data, flag }: { data: any; flag: "gain" | "loss" }) => {
  const baseDt = data?.BASE_DT
    ? moment(data.BASE_DT).tz("Asia/Seoul").format("YYYY-MM-DD")
    : "";

  const clickHandler = () => {
    // 클릭 여부만 기록 (배너는 당일 데이터 동안 계속 노출 — 도메인 이전 시 localStorage로 숨겨지는 문제 방지)
    if (!data?.ITEM_CD_DL || !baseDt) return;
    localStorage.setItem(
      `interest_newsrader_${data.ITEM_CD_DL}_${baseDt}`,
      "true"
    );
  };

  return (
    <div className="flex flex-col">
      <div className="px-[34px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="8"
          viewBox="0 0 20 8"
          fill="none"
        >
          <path d="M20 8L10 0L0 8H20Z" fill="var(--gray10)" />
        </svg>
      </div>

      <TrackedNewsRaderLink
        href={`/detail/${data?.ITEM_CD_DL}?tab=aireport&sub=news`}
        ticker={data?.ITEM_CD_DL}
        newsraderId={data?.ID}
        fromListId="watchlist_banner_newsradar"
        rank={1}
        asTrace={true}
        className="flex  bg-gray10 px-6 py-[10px] cursor-pointer gap-3 items-center"
        onClick={clickHandler}
        data-gtm-id={`watchlist-newsrader-stock-banner`}
      >
        <p
          className={`${TYPO.TYPO7_1_SB} ${
            flag === "gain" ? "text-red50" : "text-blue50"
          }`}
        >
          {flag === "gain" ? "상승" : "하락"}
        </p>
        <p
          className={`${TYPO.TYPO7_1_MD} text-gray80 whitespace-pre-line grow text-left`}
        >
          {data?.KEYWORD?.split(",").join("\n")}
        </p>
        <Forward fill="gray40" height={12} width={12} />
      </TrackedNewsRaderLink>
    </div>
  );
};

function InterestAssetList({
  sortedData,
  isValid,
  toggleActive,
  t,
  session,
  newsRaderData,
}: {
  sortedData: any;
  isValid: boolean;
  toggleActive: boolean;
  t: any;
  session: any;
  newsRaderData: any;
}) {
  const router = useRouter();

  const [resentMarketDay, setIsKoreanHoliday] = useState<string>("");
  const fetchKoreanHoliday = async () => {
    try {
      const data = await fetch(`/api/holiday?ko=true&includeToday=true`);
      const { resentMarketDay } = await data.json();
      setIsKoreanHoliday(resentMarketDay);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    fetchKoreanHoliday();
  }, []);

  if (isValid)
    return (
      <div>
        <Loading />
      </div>
    );
  if (!sortedData || sortedData?.length === 0)
    return <InterestNoList session={session} />;

  // 가장 최근 한국 영업일 뉴스레이더 데이터 필터링
  const daliyNewsRaderFilteredData = newsRaderData?.filter((item: any) =>
    moment(item?.BASE_DT)
      .tz("Asia/Seoul")
      .isSame(moment(resentMarketDay), "day")
  );

  // 뉴스레이더 데이터에 있는 종목들의 ITEM_CD_DL 목록
  const newsRaderItemCodes =
    daliyNewsRaderFilteredData?.map((item: any) => String(item?.ITEM_CD_DL)) ||
    [];

  // 뉴스레이더 데이터에 있는 종목들만 필터링 (한국 종목, 장 마감 후 데이터)
  const newsRaderRelatedAssets = sortedData?.filter(
    (item: any) =>
      !item?.IS_5MIN &&
      item?.LOC === KOREA &&
      newsRaderItemCodes.includes(String(item?.ITEM_CD_DL))
  );

  // 뉴스레이더 관련 종목들을 수익률 기준으로 정렬
  const sortedNewsRaderAssets = newsRaderRelatedAssets?.sort(
    (a: any, b: any) => b.ADJ_CLOSE_CHG - a.ADJ_CLOSE_CHG
  );

  console.log(
    "moment(resentMarketDay)",
    moment(resentMarketDay).tz("Asia/Seoul")?.format("YYYY-MM-DD")
  );
  console.log(
    `  moment(item?.BASE_DT).tz("Asia/Seoul")`,
    moment(newsRaderData?.[0]?.BASE_DT).tz("Asia/Seoul")?.format("YYYY-MM-DD")
  );

  // 뉴스레이더 데이터에서 수익률 최고/최저 종목의 데이터 찾기
  const topGainData =
    sortedNewsRaderAssets?.length > 0
      ? daliyNewsRaderFilteredData?.find(
          (item: any) =>
            String(item?.ITEM_CD_DL) ===
              String(sortedNewsRaderAssets[0]?.ITEM_CD_DL) &&
            item?.ADJ_CLOSE_CHG > 0
        )
      : null;

  const topLossData =
    sortedNewsRaderAssets?.length > 0
      ? daliyNewsRaderFilteredData?.find(
          (item: any) =>
            String(item?.ITEM_CD_DL) ===
              String(
                sortedNewsRaderAssets[sortedNewsRaderAssets.length - 1]
                  ?.ITEM_CD_DL
              ) && item?.ADJ_CLOSE_CHG < 0
        )
      : null;

  return (
    <div className=" flex flex-col  border-b-gray-100">
      <TrackedList
        listId="watchlist_stock_list"
        totalCount={sortedData?.length}
      >
        <div className="pt-4 flex flex-col gap-2">
          {sortedData?.map((asset: any, i: number) => (
            <ul key={i} className=" flex justify-between  gap-3 w-full">
              <TrackedListItem
                itemData={{
                  kind: "stock",
                  ticker: asset.ITEM_CD_DL,
                  market: asset.LOC === KOREA ? "kr" : "us",
                  rank: i + 1,
                }}
                href={`/detail/${asset.ITEM_CD_DL}`}
                className="w-full"
                data-gtm-id={`watchlist-asset-list`}
              >
                <div className="relative">
                  <List
                    src={getStockLogo(asset.ITEM_CD_DL)}
                    item={
                      router.locale === "ko"
                        ? asset.ITEM_KR_NM && asset.ITEM_KR_NM
                        : asset.ITEM_ENG_NM && asset.ITEM_ENG_NM
                    }
                    HR_ITEM_NM={asset.HR_ITEM_NM}
                    rightIcon={() => {
                      // 주석 처리된 price 로직 구현
                      const price =
                        asset.CAT === "Index"
                          ? asset.ADJ_CLOSE &&
                            asset.ADJ_CLOSE.toLocaleString("en-us", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })
                          : !toggleActive
                          ? asset.ADJ_CLOSE &&
                            asset.ADJ_CLOSE.toLocaleString("en-us", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2,
                            }) +
                              (asset.CAT !== "Index"
                                ? ` ${asset?.CURR ? asset?.CURR : ""}`
                                : "")
                          : router.locale === "ko"
                          ? asset.ADJ_CLOSE_KRW &&
                            asset.ADJ_CLOSE_KRW.toLocaleString("en-us", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }) + (asset.CAT !== "Index" ? "원" : "")
                          : asset.ADJ_CLOSE_USD &&
                            asset.ADJ_CLOSE_USD.toLocaleString("en-us", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }) + (asset.CAT !== "Index" ? "$" : "");

                      // 주석 처리된 percent 로직 구현
                      const percent = asset?.ADJ_CLOSE_CHG
                        ? asset.ADJ_CLOSE_CHG.toLocaleString("en-us", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          })
                        : "";

                      return (
                        <div
                          className={`truncate shrink-0 justify-end items-end flex flex-col grow`}
                        >
                          {/* Percent 표시 */}
                          {(percent || String(Number(percent)) === "0") && (
                            <span
                              className={`${
                                Number(percent) > 0
                                  ? "text-rose-500"
                                  : Number(percent) === 0
                                  ? "text-gray60"
                                  : "text-blue-500"
                              } ${TYPO.TYPO5_1_MD} overflow-hidden truncate`}
                            >
                              {Number(percent) > 0 ? "+" : ""}
                              {Number(percent) === 0 ? "0.0" : Number(percent)}%
                            </span>
                          )}
                          {/* Price 표시 */}
                          {price && (
                            <span
                              className={`text-gray50 ${TYPO.TYPO8_RG}  whitespace-pre-wrap `}
                            >
                              {price}
                            </span>
                          )}
                        </div>
                      );
                    }}
                  />
                  {asset?.ITEM_CD_DL === topGainData?.ITEM_CD_DL && (
                    <TopGainLoss data={topGainData} flag="gain" />
                  )}
                  {asset?.ITEM_CD_DL === topLossData?.ITEM_CD_DL && (
                    <TopGainLoss data={topLossData} flag="loss" />
                  )}
                </div>
              </TrackedListItem>
            </ul>
          ))}
        </div>
      </TrackedList>
    </div>
  );
}

export default InterestAssetList;
